mutation UpdateInboundFacebookRules($input: InboundFacebookRulesUpdateInput!) {
    inboundFacebookRulesUpdate(input: $input) {
        assignment {
            assignedUser {
                id
                name
            }
        }
    }
}
